/** Shared upload cap for document-parse and incident attachments (binary size). */
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
export const MAX_UPLOAD_SIZE_LABEL = '50 MB';
export const UPLOAD_TOO_LARGE_MESSAGE = `File is too large. Maximum size is ${MAX_UPLOAD_SIZE_LABEL}.`;
export function isUploadTooLarge(sizeBytes) {
    return !Number.isFinite(sizeBytes) || sizeBytes < 0 || sizeBytes > MAX_UPLOAD_BYTES;
}
